module.exports = __webpack_public_path__ + "static/media/list-alt.d48d341d.svg";